<template>
  <div>
    <div class="searchContainer">
      <a-input
        class="search-item"
        size="large"
        v-model:value="paramQuery.id"
        placeholder="满意度ID"
        allowClear
        :maxlength="19"
        @input="inputFormat($event, 'id', 3)"
      />
      <a-input
        class="search-item"
        size="large"
        allowClear
        v-model:value="paramQuery.workOrderId"
        placeholder="工单ID"
        :maxlength="19"
        @input="inputFormat($event, 'workOrderId', 3)"
      />
      <a-input
        class="search-item"
        size="large"
        allowClear
        v-model:value="paramQuery.assistantName"
        placeholder="健管姓名"
        :maxlength="19"
        @input="inputFormat($event, 'assistantName', 1)"
      />
      <a-input
        class="search-item"
        size="large"
        allowClear
        v-model:value="paramQuery.ucPatientId"
        placeholder="患者ID"
        :maxlength="19"
        @input="inputFormat($event, 'ucPatientId', 3)"
      />
      <a-input
        class="search-item"
        size="large"
        allowClear
        v-model:value="paramQuery.patientName"
        placeholder="患者姓名"
        :maxlength="20"
        @input="inputFormat($event, 'patientName', 1)"
      />
      <a-select
        v-model:value="paramQuery.evaluateStatus"
        placeholder="评价状态"
        class="search-item"
        size="large"
        :options="satisfactStatus"
        allowClear
      ></a-select>
      <a-select
        v-model:value="paramQuery.evaluateResult"
        placeholder="评价结果"
        class="search-item"
        size="large"
        :options="satisfactResult"
        allowClear
      ></a-select>
      <a-range-picker
        class="search-item search-date"
        :placeholder="['创建开始时间', '创建结束时间']"
        size="large"
        format="YYYY-MM-DD"
        v-model:value="creatTimeRange"
        :showTime="showTimeConfig"
        valueFormat="YYYY-MM-DD HH:mm:ss"
      />
      <a-range-picker
        class="search-item search-date"
        :placeholder="['评价开始时间', '评价结束时间']"
        size="large"
        format="YYYY-MM-DD"
        v-model:value="evaluteTimeRange"
        :showTime="showTimeConfig"
        valueFormat="YYYY-MM-DD HH:mm:ss"
      />
      <a-button size="large" type="primary" @click="handleSearch(true)" class="search-btn">
        搜索
      </a-button>
      <a-button size="large" @click="handleRest" class="search-btn">重置</a-button>
    </div>
    <a-row type="flex" justify="end">
      <a-button
        size="large"
        type="primary"
        :loading="exportLoading"
        @click="handleSearch(false)"
        class="search-export"
      >
        导出
      </a-button>
    </a-row>
  </div>
</template>

<script setup>
import { ref, reactive, defineEmits, defineProps, watch } from 'vue'
import { satisfactStatus, satisfactResult } from './config'
import { inputRule } from '@/utils/validate'
import moment from 'moment'
import { cloneDeep } from 'lodash-es'

const emits = defineEmits(['changeQuery', 'exportQuery'])
const props = defineProps({
  queryParams: {
    type: Object,
    default: () => ({})
  },
  exportLoading: {
    type: Boolean,
    default: false
  }
})
const creatTimeRange = ref(null)
const evaluteTimeRange = ref(null)
const defaultQuery = reactive({
  id: null,
  workOrderId: null,
  assistantName: null,
  ucPatientId: null,
  patientName: null,
  evaluateStatus: null,
  evaluateResult: null,
  createdAtStart: null,
  createdAtEnd: null,
  evaluateTimeStart: null,
  evaluateTimeEnd: null
})
const showTimeConfig = reactive({
  format: 'HH:mm:ss',
  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
})

const paramQuery = reactive({
  ...defaultQuery
})

function inputFormat(e, key, type) {
  paramQuery[key] = inputRule(e.target.value, type)
}

const handleRest = () => {
  Object.assign(paramQuery, defaultQuery)
  creatTimeRange.value = null
  evaluteTimeRange.value = null
  emits('changeQuery', cloneDeep(paramQuery))
}

const handleSearch = type => {
  const [cStart, cEnd] = creatTimeRange.value || []
  const [eStart, eEnd] = evaluteTimeRange.value || []
  paramQuery.createdAtStart = cStart
  paramQuery.createdAtEnd = cEnd
  paramQuery.evaluateTimeStart = eStart
  paramQuery.evaluateTimeEnd = eEnd
  type ? emits('changeQuery', cloneDeep(paramQuery)) : emits('exportQuery', cloneDeep(paramQuery))
}

watch(
  () => props.queryParams,
  value => {
    const nextQuery = {
      ...defaultQuery,
      ...cloneDeep(value || {})
    }
    Object.assign(paramQuery, nextQuery)

    const createRange = [nextQuery.createdAtStart, nextQuery.createdAtEnd].filter(Boolean)
    const evaluateRange = [nextQuery.evaluateTimeStart, nextQuery.evaluateTimeEnd].filter(Boolean)
    creatTimeRange.value = createRange.length === 2 ? createRange : null
    evaluteTimeRange.value = evaluateRange.length === 2 ? evaluateRange : null
  },
  {
    immediate: true,
    deep: true
  }
)
</script>

<style lang="scss" scoped>
.searchContainer {
  background-color: #fff;
  padding: 10px 20px 0;

  .search-item {
    width: 224px;
    margin: 0 12px 10px 0;
  }
  .search-date {
    width: 280px;
  }
  .search-btn {
    width: 80px;
    margin: 0 12px 10px 0;
  }
}
.search-export {
  width: 80px;
  margin: 20px 20px 10px 20px;
}
</style>
